type ChartVariant = "stockdio" | "embed";

type ClarityFn = (...args: unknown[]) => void;

const getClarity = (): ClarityFn | null => {
	if (typeof window === "undefined") return null;
	const maybeClarity = (window as Window & { clarity?: ClarityFn }).clarity;
	return typeof maybeClarity === "function" ? maybeClarity : null;
};

const withChartVariantTag = (clarity: ClarityFn, variant: ChartVariant) => {
	clarity("set", "chart_variant", variant);
};

export const setClarityChartVariant = (variant: ChartVariant) => {
	const clarity = getClarity();
	if (!clarity) return;
	withChartVariantTag(clarity, variant);
	clarity("event", `chart_ab_variant_${variant}`);
};

export const trackClarityChartExposure = (params: {
	variant: ChartVariant;
	context: string;
	chartCount: number;
	symbol?: string | null;
}) => {
	const clarity = getClarity();
	if (!clarity) return;
	withChartVariantTag(clarity, params.variant);
	clarity("set", "chart_context", params.context);
	clarity("set", "chart_count", String(Math.max(0, params.chartCount)));
	if (params.symbol) {
		clarity("set", "chart_symbol", params.symbol.toUpperCase());
	}
	clarity("event", "chart_ab_exposure");
	clarity("event", `chart_ab_exposure_${params.variant}`);
};

export const trackClarityChartInteraction = (params: {
	variant: ChartVariant;
	context: string;
	interaction: "range_change" | "chart_type_change" | "iframe_focus";
	value: string;
	symbol?: string | null;
}) => {
	const clarity = getClarity();
	if (!clarity) return;
	withChartVariantTag(clarity, params.variant);
	clarity("set", "chart_context", params.context);
	clarity("set", "chart_interaction", params.interaction);
	clarity("set", "chart_interaction_value", params.value);
	if (params.symbol) {
		clarity("set", "chart_symbol", params.symbol.toUpperCase());
	}
	clarity("event", `chart_ab_${params.interaction}`);
	clarity("event", `chart_ab_${params.interaction}_${params.variant}`);
};
